import React, {useEffect, useState} from 'react';
import {withNavigation} from '../navigation/navigation';
import {useNotificationList} from './hooks/useNotificationList';
import {Box, Skeleton, Stack, Typography} from '@mui/material';
import NotificationItem from './NotificationItem';
import {MenuItem, Select} from '@mui/material';
import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {useNotificationConfigList} from '../configuration/notification/hooks/notificationConfigList';
import {withNotificationConfigListContext} from '../configuration/notification/context/notificationConfigList';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const NotificationList = ({setShowNav}) => {
  const {mode} = useDarkMode();
  const Btn = styled('button')({
    background: 'unset',
    border: 'unset',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: mode.darkMode ? '#464647' : '#F0F2F8',
    },
    padding: 5,
    position: 'relative',
  });

  const {notificationConfigs, loading: confLoading} =
    useNotificationConfigList();
  const {loading, notifications, markAllAsRead, markAsReaded} =
    useNotificationList(true);
  useEffect(() => setShowNav(false), []);

  const [selected, setSelected] = useState(-1);

  return (
    <Box
      style={{
        alignSelf: 'flex-start',
        width: '100%',
        flexGrow: 1,
        backgroundColor: mode.settings.cardBackgroundColor,
      }}>
      <Box style={{padding: 15}}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flexWrap={'wrap'}>
          <Stack direction="row" gap={10}>
            <Typography variant="h3" sx={{color: mode.settings.textColor3}}>
              Notifications
            </Typography>
            <Select
              value={selected}
              variant="standard"
              sx={{
                '&::after': {
                  display: 'none',
                },
                '&::before': {
                  display: 'none',
                },
                fontSize: '14px',
                '& svg': {
                  // targeting the svg element
                  color: mode.settings.textColor3, // replace 'red' with the color you want
                },
              }}
              onChange={e => setSelected(e.target.value)}>
              <MenuItem value={-1}>
                <Typography
                  sx={{color: mode.settings.textColor3}}
                  variant={'subtitle9'}>
                  Voir tous
                </Typography>
              </MenuItem>
              {!confLoading &&
                notificationConfigs.map(conf => (
                  <MenuItem
                    sx={{color: mode.settings.textColor3}}
                    key={conf.id}
                    value={conf.id}>
                    {conf.title}
                  </MenuItem>
                ))}
            </Select>
          </Stack>
          <Stack direction="row" gap={6}>
            <Btn onClick={markAllAsRead}>
              <Typography
                sx={{color: mode.settings.textColor3}}
                variant={'subtitle9'}>
                Tout marquer comme lu
              </Typography>
              {mode.darkMode ? (
                <img src="assets/icon/checked-white.png" />
              ) : (
                <img src="assets/icon/checked.png" />
              )}
            </Btn>
            <Btn>
              <Typography
                sx={{color: mode.settings.textColor3}}
                variant={'subtitle9'}>
                Paramètres
              </Typography>
              {mode.darkMode ? (
                <img src="assets/icon/settings-white.png" />
              ) : (
                <img src="assets/icon/settings.png" />
              )}
              <Link
                to={'/configurations/notification'}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'block',
                }}
              />
            </Btn>
          </Stack>
        </Stack>
        <Stack pl={5}>
          {notifications
            .filter(notification => {
              if (-1 === selected) return true;

              return notification.notification.id === selected;
            })
            .map((notification, index) => (
              <NotificationItem
                {...notification}
                key={index}
                markAsReaded={markAsReaded}
                notificationId={notification.id}
                //onClick={async () => markAsReaded(notification.id)}
              />
            ))}
          {loading &&
            Array(3)
              .fill(1)
              .map((_, index) => (
                <Stack
                  direction="row"
                  sx={{width: '100%'}}
                  alignItems="center"
                  gap={3}>
                  <Skeleton variant="circular" width={45} height={45} />
                  <Skeleton key={index} height={130} width={'100%'} />
                </Stack>
              ))}
        </Stack>
        {!loading && notifications.length === 0 && (
          <Typography>Aucune notification</Typography>
        )}
      </Box>
    </Box>
  );
};

export default withNotificationConfigListContext(
  withNavigation(NotificationList),
);
